import { Link as ChakraLink, LinkProps as ChakraLinkProps } from '@chakra-ui/react';
import NextLink from 'next/link';
import { forwardRef } from 'react';

export type LinkProps = ChakraLinkProps & {
   href: string;
};

export const Link = forwardRef(function ({ href, children, ...chakraProps }: LinkProps, ref) {
   return (
      <NextLink href={href ?? ''} passHref legacyBehavior>
         <ChakraLink
            // @ts-ignore
            ref={ref}
            {...chakraProps}
         >
            {children}
         </ChakraLink>
      </NextLink>
   );
});
